export const ORGANIZATION_COURSE_CARD_TRANSLATION_KEY =
  'organization-course-card';
